import { render, staticRenderFns } from "./EditGap.vue?vue&type=template&id=1c4a84e1"
import script from "./EditGap.vue?vue&type=script&lang=js"
export * from "./EditGap.vue?vue&type=script&lang=js"
import style0 from "./EditGap.vue?vue&type=style&index=0&id=1c4a84e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports